var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import model from '../base.model';
import { isEmail, minLength } from '../../utils/validation.helper';
import { isEmpty } from '../../utils/helpers';
import { clearError } from '../../actions/common.actions';
import { errorModel } from '../service/error.model';

class loginModelForm extends model {

    static create() {
        return _extends({}, super.create(), {
            email: '',
            emailError: '',
            password: '',
            passwordError: '',
            isValid: true
        });
    }

    //region init

    //endregion

    //region form

    static validate(clientModel) {
        let { email, password } = clientModel;
        let emailError = isEmpty(email) ? 'Empty' : isEmail(email);
        let passwordError = isEmpty(password) ? 'Empty' : minLength(4)(password);

        emailError = emailError && 'Please check the correctness of the email address';
        passwordError = passwordError && 'Password ' + passwordError.toLowerCase();

        const isValid = !passwordError && !emailError;

        return {
            isValid,
            email,
            emailError,
            password,
            passwordError
        };
    }

    static getPlaceholders(form, error) {
        const {
            isValid,
            email,
            password,
            passwordError
        } = form;

        let emailPlaceholder = 'User name';
        let passwordPlaceholder = 'Password';

        // validation by network error
        let emailError = '';
        if (error && error.message) {
            // emailError = error.message;
            emailError = errorModel.isNetworkError(error.message) ? error.message : 'Credentials are invalid';
        }

        return {
            emailError,
            emailPlaceholder,
            passwordPlaceholder
        };
    }

    //endregion

    //region actions

    static actionOnClearForm(model, clientModel) {
        return dispatch => {
            return dispatch({
                type: model.TYPE_ON_CLEAR_FORM,
                payload: { model, clientModel }
            });
        };
    }

    static actionOnValidate(model, form) {
        return dispatch => {
            return dispatch({
                type: model.TYPE_ON_VALIDATE_FORM,
                payload: { model, form }
            });
        };
    }

    static actionOnChangeEmail(model, email) {
        return dispatch => {
            dispatch(clearError());
            return dispatch({
                type: model.TYPE_ON_CHANGE_EMAIL,
                payload: { model, email }
            });
        };
    }

    static actionOnChangePassword(model, password) {
        return dispatch => {
            dispatch(clearError());
            return dispatch({
                type: model.TYPE_ON_CHANGE_PASSWORD,
                payload: { model, password }
            });
        };
    }

    //endregion

    //region reducer

    static getReduceMethod(model, type) {
        const reduceMethod = super.getReduceMethod(model, type);
        if (reduceMethod) {
            return reduceMethod;
        }
        const reducers = {
            [model.TYPE_ON_CLEAR_FORM]: model.reduceOnClearForm,
            [model.TYPE_ON_VALIDATE_FORM]: model.reduceOnValidateForm,
            [model.TYPE_ON_CHANGE_EMAIL]: model.reduceOnChangeEmail,
            [model.TYPE_ON_CHANGE_PASSWORD]: model.reduceOnChangePassword
        };

        return reducers[type];
    }

    static reduceOnClearForm(stateModel, action) {
        const { model, clientModel } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, model.create(), clientModel, {
                password: ''
            })
        };
    }

    static reduceOnValidateForm(stateModel, action) {
        const { model, form } = action.payload;
        const { isValid, password } = form;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, form, {
                password: isValid ? password : ''
            })
        };
    }

    static reduceOnChangeEmail(stateModel, action) {
        const { model, email } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                isValid: true,
                email,
                emailError: ''
            })
        };
    }

    static reduceOnChangePassword(stateModel, action) {
        const { model, password } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                isValid: true,
                password,
                passwordError: ''
            })
        };
    }
}

loginModelForm.MODEL_NAME = 'loginModelForm';
loginModelForm.TYPE_ON_CLEAR_FORM = 'TYPE_LOGIN__ON_CLEAR_FORM';
loginModelForm.TYPE_ON_VALIDATE_FORM = 'TYPE_ON_LOGIN__VALIDATE_FORM';
loginModelForm.TYPE_ON_CHANGE_EMAIL = 'TYPE_LOGIN__ON_CHANGE_EMAIL';
loginModelForm.TYPE_ON_CHANGE_PASSWORD = 'TYPE_LOGIN__ON_CHANGE_PASSWORD';
export { loginModelForm };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/auth/login.model.form.js